export default __webpack_public_path__ + "static/media/img_fee_85.130caa36.svg";